import { IFareManagementState } from "@/core/interfaces/state/fareManagementState.interface";

const state: IFareManagementState = {
  isSabreFaresLoading: false,
  sabreFares: null,
};

export default state;
